var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7091 0C2.56408 0 0 2.56408 0 5.7091C0 8.85412 2.56408 11.4182 5.7091 11.4182C7.03032 11.4182 8.24824 10.9652 9.21766 10.2072L12.8055 13.7951C13.0788 14.0683 13.5218 14.0683 13.7951 13.7951C14.0683 13.5218 14.0683 13.0788 13.7951 12.8055L10.2072 9.21769C10.9655 8.24854 11.4196 7.03035 11.4196 5.70913C11.4196 2.56411 8.85413 0 5.7091 0ZM5.7091 1.39962C8.09771 1.39962 10.02 3.32049 10.02 5.70913C10.02 8.09774 8.09774 10.0186 5.7091 10.0186C3.32046 10.0186 1.39956 8.09774 1.39959 5.70913C1.39959 3.32049 3.32046 1.39962 5.7091 1.39962Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.17d2732bf892150d7df2080ba20a3667.svg";
export { ForwardRef as ReactComponent };